import { cn } from '@fruuit/ui'
import { CircleHelp } from 'lucide-react'
import { Link, useLocation } from 'react-router'

/** The Help entry at the bottom of every area's side nav (desktop aside and mobile drawer). */
export function HelpNavLink({ className }: { className?: string }) {
  const { pathname } = useLocation()
  const active = pathname === '/help' || pathname.startsWith('/help/')
  return (
    <nav aria-label="Help" className={className}>
      <Link
        to="/help"
        aria-current={active ? 'page' : undefined}
        className={cn(
          'group flex items-center gap-3 rounded-md px-3 py-2.5 text-sm no-underline transition-colors',
          active
            ? 'bg-teal font-semibold text-white shadow-[0_4px_10px_rgb(22_62_58/0.14)]'
            : 'font-medium text-teal hover:bg-wash-strong',
        )}
      >
        <CircleHelp
          aria-hidden="true"
          className={cn(
            'size-[18px] shrink-0',
            active ? 'text-white' : 'text-teal-500 group-hover:text-teal',
          )}
        />
        Help
      </Link>
    </nav>
  )
}
